import './PurchaseTable.scss';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { RaflTheme } from '../../../theme';



import PurchaseRow from './PurchaseRow';


const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowY: 'hidden'
}));
const StyledTableCell = styled(TableCell)(({ theme }) => {
  const t = (theme && theme.spacing) ? theme : RaflTheme;


  return {
    paddingLeft: t.spacing(2),
    paddingRight: t.spacing(1),
    fontWeight: 600,
  };

});


// Table Head Preparation
const headCells = [
  { id: 'enrichment', numeric: false, disablePadding: false, label: '' },
  { id: 'assetImage', numeric: false, disablePadding: false, label: 'Asset' },
  { id: 'assetDamId', numeric: false, disablePadding: false, label: 'DAM-Id' },
  { id: 'credit', numeric: false, disablePadding: false, label: 'FotoCredit' },
  { id: 'assetForeignId', numeric: true, disablePadding: false, label: 'Fremd‐Id' },
  { id: 'department', numeric: false, disablePadding: true, label: 'Ressort' },
  { id: 'vendor', numeric: false, disablePadding: true, label: 'Anbieter' },
  { id: 'caption', numeric: false, disablePadding: true, label: 'Beschreibung' },
  { id: 'price', numeric: false, disablePadding: false, label: 'Honorar' },
  { id: 'onlineTime', numeric: false, disablePadding: false, label: 'Standzeit' },
  { id: 'Usages', numeric: false, disablePadding: false, label: 'Verwendungen' }
];

const PurchaseTable = ({ purchases, pendingCreditAdviceJobs, handleAssetDetails, handleSelectPurchase, isSelected, shouldShowCheckboxes, pendingMetadataJobs, isLoading }) => {

  return (
      <StyledTableContainer component={Paper}>
        <Table className='purchaseTable' aria-label='simple table'>
          <TableHead className='table__head'>
            <TableRow>
              {headCells.map(headCell => (
                <StyledTableCell
                  align={'left'}
                  padding={headCell.disablePadding ? 'none' : 'normal'}
                  key={headCell.id}
                >
                  {headCell.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              purchases && purchases.length > 0 ?
                purchases.map((purchase, idx) => {
                  const shouldDisableCheckbox = shouldShowCheckboxes && ( pendingMetadataJobs.includes(purchase.assetId.damAssetId) ||  pendingCreditAdviceJobs.includes(purchase.assetId.damAssetId)|| !!purchase.creditAdviceId.serialNumber )
                  return (
                    <PurchaseRow
                      key={idx}
                      purchase={purchase}
                      index={idx}
                      handleAssetDetails={handleAssetDetails}
                      handleSelectPurchase={handleSelectPurchase}
                      isSelected={isSelected}
                      shouldShowCheckbox={shouldShowCheckboxes && !isLoading}
                      shouldDisableCheckbox={shouldDisableCheckbox}
                    />
                  )
                }) :
                (
                  <TableRow key='1'>
                    <TableCell style={{ textAlign: 'center' }} colSpan={headCells.length} component='th' scope='row'>
                      Keine Verwendungen gefunden
                    </TableCell>
                  </TableRow>
                )
            }
          </TableBody>
        </Table>
      </StyledTableContainer>
  );
};

export default PurchaseTable;
